import { render, staticRenderFns } from "./HelpPage.vue?vue&type=template&id=3d20ab7e&scoped=true&"
import script from "./HelpPage.vue?vue&type=script&lang=ts&"
export * from "./HelpPage.vue?vue&type=script&lang=ts&"
import style0 from "./HelpPage.vue?vue&type=style&index=0&id=3d20ab7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d20ab7e",
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QIcon});
